import classNames from 'classnames'

import { IStatistic } from 'models/statistic'

import styles from './AppStatistics.module.scss'

interface AppStatisticsProps {
  list: IStatistic[]
}
export const AppStatistics = ({ list }: AppStatisticsProps) => {
  return (
    <ul className={styles.container}>
      {list.map(status => {
        return (
          <li
            key={status.status_code}
            className={classNames(styles.item, styles[status.status_code])}
          >
              {status.status_name} <b>{status.count}</b>
          </li>
        )
      })}
    </ul>
  )
}
